import React from "react";
import moment from "moment";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import "./index.css";
import AddCompetition from "./components/AddCompetition";
import delete_icon from "../../assets/media/feeds/delete.png";
import CompetitionDetail from "./CompetitionDetail";

class Competitions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      loading: true,
      posts: [],
      users: [],
    };
  }

  componentDidMount() {
    if (!this.props.location.state) this.props.history.push("/");
    else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });
      Firebase.getBrandDataByID(brand, (brand_data) => {
        this.setState({
          logo: brand_data.logo,
          icon: brand_data.icon,
          brand_name: brand_data.name,
          brand_url: brand_data.url,
          hex: brand_data.hex,
          white: brand_data.white,
          is_property_brand: brand_data.is_property_brand
            ? brand_data.is_property_brand
            : false,
        });

        Firebase.getAllCompetitions(
          brand_data.name,
          this.subscribeCompetitions
        );
        Firebase.getAllUsers(brand_data.name, this.subscribeUsers);
      });
    }
  }

  subscribeCompetitions = (posts) => {
    posts.sort((a, b) => b.timestamp.seconds - a.timestamp.seconds);
    this.setState({ posts, loading: false });
  };

  subscribeUsers = (users) => {
    this.setState({ users });
  };

  getTimePosted = (post) => {
    const date = moment.unix(post.timestamp.seconds);
    return date.format("hh:mm:ss");
  };

  getDatePosted = (post) => {
    const date = moment.unix(post.timestamp.seconds);
    return date.format("DD/MM/YYYY");
  };

  getPostedBy = (post) => {
    const { users } = this.state;
    const user = users.find((item) => item.id === post.uid);
    if (user) {
      return `${user.firstname} ${user.lastname || ""}`;
    }

    return "Unknown";
  };

  onAdd = async (
    title,
    image_content,
    content,
    task,
    postNow,
    scheduledDate,
    runUntil,
    hot_topic
  ) => {
    const { brand_name, username } = this.state;
    let folder = "posters/" + brand_name;
    let image_url = await Firebase.uploadImage(
      image_content,
      `competition_${moment().valueOf()}`,
      folder
    );

    let avatar_url = "";

    let post = {
      title,
      image_url,
      uid: localStorage.getItem("uid"),
      content,
      username,
      avatar_url,
      task,
      postNow,
      scheduledDate: postNow ? moment().valueOf() : scheduledDate.valueOf(),
      runUntil: runUntil.valueOf(),
      hot_topic,
    };
    let res = await Firebase.addCompetition(post, brand_name);
    if (!postNow) {
      let schedule_data = {
        id: res.id,
        type: "competition",
        time: scheduledDate.valueOf(),
        brand_name: brand_name,
      };
      let schedule_res = await Firebase.registerSchedule(schedule_data);
      console.log("schedule_res", schedule_res);
    }
  };

  deleteCompetition = (post) => {
    const { brand_name } = this.state;
    Firebase.deleteCompetition(brand_name, post.id);
  };

  renderCompetitions = () => {
    const { posts, brand_name } = this.state;
    return (
      <div>
        <button
          className="btn-add btn-brand-hex"
          data-toggle="modal"
          data-target="#add_competition_modal"
          style={{
            backgroundColor: "white",
            color: "black",
            "--hover-text-color": this.state.white ? "white" : "black",
            "--hover-color": this.state.hex,
          }}
        >
          <p style={{ fontSize: "65px", lineHeight: "65px" }}>+</p>
          <p className="event-item-text">Add a new competition</p>
        </button>
        {posts
          .filter((post) => post.accepted !== false)
          .map((post, index) => (
            <div className="competition-container" key={index}>
              <div
                className="img-container"
                style={{ backgroundImage: `url("${post.img_url}")` }}
              >
                <img
                  src={delete_icon}
                  width="30"
                  onClick={() => this.deleteCompetition(post)}
                  alt="delete-icon"
                />
              </div>
              <CompetitionDetail
                post={post}
                users={this.state.users}
                brand_name={brand_name}
              />
            </div>
          ))}
      </div>
    );
  };

  render() {
    const {
      username,
      role,
      logo,
      brand,
      is_property_brand,
      loading,
      brand_name,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container" className="competitions-content">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          )}
          {!loading && this.renderCompetitions()}
          <AddCompetition onAdd={this.onAdd} brand_name={brand_name} />
        </main>
      </div>
    );
  }
}
export default Competitions;



// WEBPACK FOOTER //
// ./src/screens/Competitions/index.js